<template>
  <div class="home">
    <div class="row">
      <div class="col-md-12">
        <!--begin::Portlet-->
        <div class="m-portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <span class="m-portlet__head-icon m--hide">
                  <i class="la la-gear"></i>
                </span>
                <h3 class="m-portlet__head-text">Exam</h3>
              </div>
            </div>
          </div>
          <div class="m-portlet__body">
            <div class="row">
              <div class="col-md-12">
                <div class="exam-content">
                  <div class="m-portlet m-portlet--tabs">
                    <div class="m-portlet__head">
                      <div class="m-portlet__head-tools">
                        <ul class="nav nav-tabs m-tabs-line m-tabs-line--primary m-tabs-line--2x" role="tablist">
                          <li class="nav-item m-tabs__item">
                            <a class="nav-link m-tabs__link active show" data-toggle="tab" href="#m_tabs_6_1" role="tab" aria-selected="true">
                              Overview
                            </a>
                          </li>
                          <li class="nav-item m-tabs__item">
                            <a class="nav-link m-tabs__link" data-toggle="tab" href="#m_tabs_6_2" role="tab" aria-selected="false">
                              Browse Exam
                            </a>
                          </li>
                          <li class="nav-item m-tabs__item">
                            <a class="nav-link m-tabs__link" data-toggle="tab" href="#m_tabs_6_3" role="tab" aria-selected="false">
                              Payment History
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="m-portlet__body">
                      <div class="tab-content">
                        <div class="tab-pane active show" id="m_tabs_6_1" role="tabpanel">
                          <div class="row">
                            <div class="col-md-9">
                                <div class="inner-content">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <div class="top-card sheduled">
                                        <div class="img-top">
                                          <div class="circle">
                                            <img src="images/shdeule.png" />
                                          </div>
                                        </div>
                                        <div class="right-top">
                                          <h3>Sheduled Exam</h3>
                                          <div class="type-exam">
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                              <button type="button" class="btn btn-secondary">2 Online</button>
                                              <button type="button" class="btn btn-secondary">3 Offline</button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="top-card completed">
                                        <div class="img-top">
                                          <div class="circle">
                                            <img src="images/completed.png" />
                                          </div>
                                        </div>
                                        <div class="right-top">
                                          <h3>Completed Exam</h3>
                                          <div class="type-exam">
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                              <button type="button" class="btn btn-secondary">2 Online</button>
                                              <button type="button" class="btn btn-secondary">3 Offline</button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="top-card not-attend">
                                        <div class="img-top">
                                          <div class="circle">
                                            <img src="images/not-attend.png" />
                                          </div>
                                        </div>
                                        <div class="right-top">
                                          <h3>Not Attend</h3>
                                          <div class="type-exam">
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                              <button type="button" class="btn btn-secondary">2 Online</button>
                                              <button type="button" class="btn btn-secondary">3 Offline</button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="inner-content">
                                  <div class="row">
                                      <div class="col-md-12">
                                        <div class="exam-content">
                                          <div class="m-portlet m-portlet--tabs" style="background-color: #f9fafc;">
                                            <div class="m-portlet__head">
                                              <div class="m-portlet__head-caption">
                                                <div class="m-portlet__head-title">
                                                  <h3 class="m-portlet__head-text">
                                                    Online Exams
                                                  </h3>
                                                </div>
                                              </div>
                                              <div class="m-portlet__head-tools">
                                                <ul class="nav pull-right nav-tabs m-tabs-line m-tabs-line--primary m-tabs-line--2x" role="tablist">
                                                  <li class="nav-item m-tabs__item">
                                                    <a class="nav-link m-tabs__link active show" data-toggle="tab" href="#top1" role="tab" aria-selected="true">
                                                      Sheduled
                                                    </a>
                                                  </li>
                                                  <li class="nav-item m-tabs__item">
                                                    <a class="nav-link m-tabs__link" data-toggle="tab" href="#top2" role="tab" aria-selected="false">
                                                      Completed
                                                    </a>
                                                  </li>
                                                  <li class="nav-item m-tabs__item">
                                                    <a class="nav-link m-tabs__link" data-toggle="tab" href="#top3" role="tab" aria-selected="false">
                                                        Not Attend
                                                    </a>
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                            <div class="m-portlet__body">
                                              <div class="tab-content">
                                                <div class="tab-pane active show" id="top1" role="tabpanel">
                                                  <div v-if="onlineExamData.length > 0" class="m-accordion m-accordion--default m-accordion--solid m-accordion--section m-accordion--toggle-arrow" id="m_accordion_7" role="tablist">
                                                    <!--begin::Item-->
                                                    <div v-for="(exam, index) in onlineExamData" :key="index" class="m-accordion__item">
                                                        <div class="m-accordion__item-head" role="tab" :id="m_accordion_7_item_1_head" data-toggle="collapse" href="#m_accordion_7_item_1_body" aria-expanded="true">
                                                            <span class="m-accordion__item-icon ex-code">
                                                                ex34
                                                            </span>
                                                            <span class="m-accordion__item-title ex-name">
                                                                <p>Grade 5 Star silver package 2021</p>
                                                                <span class="days start"><strong>Start:</strong> 2021-04-15 at 10.30 am</span>
                                                                <span class="days end"><strong>End:</strong> 2021-04-15 at 10.30 am</span>
                                                            </span>
                                                            <div class="other-option">
                                                                <span class="badge badge-pill badge-light due">2 hour 30 minutes</span>
                                                                <a class="btn btn-primary exam-list" href="#" role="button" data-toggle="modal" data-target="#start-exam-modal">Start Exam</a>
                                                                <a class="btn btn-primary exam-list continue" href="#" role="button" data-toggle="modal" data-target="#continue-exam-modal">Continue Exam</a>                                                                  
                                                            </div>
                                                            <div class="dropdown">
                                                              <img src="images/dots.png" width="14" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                                                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">sss</div>
                                                            </div>
                                                        </div>
                                                        <div class="m-accordion__item-body collapse" id="m_accordion_7_item_1_body" role="tabpanel" aria-labelledby="m_accordion_7_item_1_head" data-parent="#m_accordion_7">
                                                            <div class="m-accordion__item-content">
                                                              <div class="row">
                                                                  <div class="col-md-8">
                                                                    <div class="left-exam">
                                                                      <div class="download-row">
                                                                        <div class="download-item">
                                                                          <a href="#">
                                                                            <img src="images/pdf.png" /> Download Question Paper
                                                                          </a>
                                                                        </div>
                                                                        <div class="download-item">
                                                                          <a href="#">
                                                                            <img src="images/pdf.png" /> Download  Answer Sheet
                                                                          </a>
                                                                        </div>
                                                                      </div>
                                                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                                                        quis nostrud exercitation ullamco laboris nisi</p>
                                                                    </div>
                                                                  </div>
                                                                  <div class="col-md-4"></div>
                                                              </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!--end::Item-->
                                                      
                                                  </div>
                                                  <div v-else>
                                                    No Online Exams Found.!
                                                  </div>
                                                </div>
                                                <div class="tab-pane" id="top2" role="tabpanel">
                                                  <div class="m-accordion m-accordion--default m-accordion--solid m-accordion--section m-accordion--toggle-arrow" id="m_accordion_7" role="tablist">
                                                      <!--begin::Item-->
                                                      <div class="m-accordion__item">
                                                          <div class="m-accordion__item-head" role="tab" id="m_accordion_28_item_1_head" data-toggle="collapse" href="#m_accordion_28_item_1_body" aria-expanded="true">
                                                              <span class="m-accordion__item-icon ex-code">
                                                                  ex34
                                                              </span>
                                                              <span class="m-accordion__item-title ex-name">
                                                                  <p>Grade 5 Star silver package 2021</p>
                                                                  <span class="days start"><strong>Start:</strong> 2021-04-15 at 10.30 am</span>
                                                                  <span class="days end"><strong>End:</strong> 2021-04-15 at 10.30 am</span>
                                                              </span>
                                                              <div class="other-option">
                                                                  <span class="badge badge-pill badge-light due">2 hour 30 minutes</span>
                                                                  <a class="btn btn-primary exam-list" href="#" role="button">Review Exam</a>
                                                                  <a class="more" href="#"><img src="images/dots.png" /></a>
                                                              </div>
                                                          </div>
                                                          <div class="m-accordion__item-body" id="m_accordion_28_item_1_body" role="tabpanel" aria-labelledby="m_accordion_28_item_1_head" data-parent="#m_accordion_7">
                                                              <div class="m-accordion__item-content">
                                                                <div class="row">
                                                                    <div class="col-md-8">
                                                                      <div class="left-exam">
                                                                        <div class="download-row">
                                                                          <div class="download-item">
                                                                            <a href="#">
                                                                              <img src="images/pdf.png" /> Download Question Paper
                                                                            </a>
                                                                          </div>
                                                                          <div class="download-item">
                                                                            <a href="#">
                                                                              <img src="images/pdf.png" /> Download  Answer Sheet
                                                                            </a>
                                                                          </div>
                                                                        </div>
                                                                          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                                                          quis nostrud exercitation ullamco laboris nisi</p>
                                                                      </div>
                                                                    </div>
                                                                    <div class="col-md-4"></div>
                                                                </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <!--end::Item-->
                                                      <!--begin::Item-->
                                                      <div class="m-accordion__item">
                                                          <div class="m-accordion__item-head collapsed" role="tab" id="m_accordion_29_item_2_head" data-toggle="collapse" href="#m_accordion_29_item_2_body" aria-expanded="    false">
                                                              <span class="m-accordion__item-icon ex-code">
                                                                  ex34
                                                              </span>
                                                              <span class="m-accordion__item-title ex-name">
                                                                  <p>Grade 5 Star silver package 2021</p>
                                                                  <span class="days start"><strong>Start:</strong> 2021-04-15 at 10.30 am</span>
                                                                  <span class="days end"><strong>End:</strong> 2021-04-15 at 10.30 am</span>
                                                              </span>
                                                              <div class="other-option">
                                                                  <span class="badge badge-pill badge-light due">2 hour 30 minutes</span>
                                                                  <a class="btn btn-primary exam-list" href="#" role="button">Review Exam</a>
                                                                  <a class="more" href="#"><img src="images/dots.png" /></a>
                                                              </div>

                                                          </div>
                                                          <div class="m-accordion__item-body collapse" id="m_accordion_29_item_2_body" role="tabpanel" aria-labelledby="m_accordion_29_item_2_head" data-parent="#m_accordion_7">
                                                              <div class="m-accordion__item-content">
                                                                <div class="row">
                                                                    <div class="col-md-8">
                                                                      <div class="left-exam">
                                                                        <div class="download-row">
                                                                          <div class="download-item">
                                                                            <a href="#">
                                                                              <img src="images/pdf.png" /> Download Question Paper
                                                                            </a>
                                                                          </div>
                                                                          <div class="download-item">
                                                                            <a href="#">
                                                                              <img src="images/pdf.png" /> Download  Answer Sheet
                                                                            </a>
                                                                          </div>
                                                                        </div>
                                                                          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                                                          quis nostrud exercitation ullamco laboris nisi</p>
                                                                      </div>
                                                                    </div>
                                                                    <div class="col-md-4"></div>
                                                                </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <!--end::Item-->
                                                  </div>
                                                </div>
                                                <div class="tab-pane" id="top3" role="tabpanel">
                                                  <div class="m-accordion m-accordion--default m-accordion--solid m-accordion--section m-accordion--toggle-arrow" id="m_accordion_7" role="tablist">
                                                      <!--begin::Item-->
                                                      <div class="m-accordion__item">
                                                          <div class="m-accordion__item-head" role="tab" id="m_accordion_38_item_1_head" data-toggle="collapse" href="#m_accordion_38_item_1_body" aria-expanded="true">
                                                              <span class="m-accordion__item-icon ex-code">
                                                                  ex34
                                                              </span>
                                                              <span class="m-accordion__item-title ex-name">
                                                                  <p>Grade 5 Star silver package 2021</p>
                                                                  <span class="days start"><strong>Start:</strong> 2021-04-15 at 10.30 am</span>
                                                                  <span class="days end"><strong>End:</strong> 2021-04-15 at 10.30 am</span>
                                                              </span>
                                                              <div class="other-option">
                                                                  <span class="badge badge-pill badge-light due">2 hour 30 minutes</span>
                                                                  <a class="btn btn-primary exam-list" href="#" role="button" data-toggle="modal" data-target="#start-exam-modal">Reattend Exam</a>
                                                                  <a class="more" href="#"><img src="images/dots.png" /></a>
                                                              </div>
                                                          </div>
                                                          <div class="m-accordion__item-body" id="m_accordion_38_item_1_body" role="tabpanel" aria-labelledby="m_accordion_38_item_1_head" data-parent="#m_accordion_7">
                                                              <div class="m-accordion__item-content">
                                                                <div class="row">
                                                                    <div class="col-md-8">
                                                                      <div class="left-exam">
                                                                        <div class="download-row">
                                                                          <div class="download-item">
                                                                            <a href="#">
                                                                              <img src="images/pdf.png" /> Download Question Paper
                                                                            </a>
                                                                          </div>
                                                                          <div class="download-item">
                                                                            <a href="#">
                                                                              <img src="images/pdf.png" /> Download  Answer Sheet
                                                                            </a>
                                                                          </div>
                                                                        </div>
                                                                          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                                                          quis nostrud exercitation ullamco laboris nisi</p>
                                                                      </div>
                                                                    </div>
                                                                    <div class="col-md-4"></div>
                                                                </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <!--end::Item-->
                                                      <!--begin::Item-->
                                                      <div class="m-accordion__item">
                                                          <div class="m-accordion__item-head collapsed" role="tab" id="m_accordion_39_item_2_head" data-toggle="collapse" href="#m_accordion_39_item_2_body" aria-expanded="    false">
                                                              <span class="m-accordion__item-icon ex-code">
                                                                  ex34
                                                              </span>
                                                              <span class="m-accordion__item-title ex-name">
                                                                  <p>Grade 5 Star silver package 2021</p>
                                                                  <span class="days start"><strong>Start:</strong> 2021-04-15 at 10.30 am</span>
                                                                  <span class="days end"><strong>End:</strong> 2021-04-15 at 10.30 am</span>
                                                              </span>
                                                              <div class="other-option">
                                                                  <span class="badge badge-pill badge-light due">2 hour 30 minutes</span>
                                                                  <a class="btn btn-primary exam-list" href="#" role="button" data-toggle="modal" data-target="#start-exam-modal">Reattend Exam</a>
                                                                  <a class="more" href="#"><img src="images/dots.png" /></a>
                                                              </div>

                                                          </div>
                                                          <div class="m-accordion__item-body collapse" id="m_accordion_39_item_2_body" role="tabpanel" aria-labelledby="m_accordion_39_item_2_head" data-parent="#m_accordion_7">
                                                              <div class="m-accordion__item-content">
                                                                <div class="row">
                                                                    <div class="col-md-8">
                                                                      <div class="left-exam">
                                                                        <div class="download-row">
                                                                          <div class="download-item">
                                                                            <a href="#">
                                                                              <img src="images/pdf.png" /> Download Question Paper
                                                                            </a>
                                                                          </div>
                                                                          <div class="download-item">
                                                                            <a href="#">
                                                                              <img src="images/pdf.png" /> Download  Answer Sheet
                                                                            </a>
                                                                          </div>
                                                                        </div>
                                                                          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                                                          quis nostrud exercitation ullamco laboris nisi</p>
                                                                      </div>
                                                                    </div>
                                                                    <div class="col-md-4"></div>
                                                                </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <!--end::Item-->
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                                <div class="inner-content">
                                  <div class="row">
                                      <div class="col-md-12">
                                        <div class="exam-content">
                                          <div class="m-portlet m-portlet--tabs" style="background-color: #f9fafc;">
                                            <div class="m-portlet__head">
                                              <div class="m-portlet__head-caption">
                                                <div class="m-portlet__head-title">
                                                  <h3 class="m-portlet__head-text">
                                                    Offline Exams
                                                  </h3>
                                                </div>
                                              </div>
                                              <div class="m-portlet__head-tools">
                                                <ul class="nav pull-right nav-tabs m-tabs-line m-tabs-line--primary m-tabs-line--2x" role="tablist">
                                                  <li class="nav-item m-tabs__item">
                                                    <a class="nav-link m-tabs__link active show" data-toggle="tab" href="#top1-offline" role="tab" aria-selected="true">
                                                      Pending
                                                    </a>
                                                  </li>
                                                  <li class="nav-item m-tabs__item">
                                                    <a class="nav-link m-tabs__link" data-toggle="tab" href="#top2-offline" role="tab" aria-selected="false">
                                                      Completed
                                                    </a>
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                            <div class="m-portlet__body">
                                              <div class="tab-content">
                                                <div class="tab-pane active show" id="top1-offline" role="tabpanel">
                                                  <div class="m-accordion m-accordion--default m-accordion--solid m-accordion--section m-accordion--toggle-arrow" id="m_accordion_7" role="tablist">
                                                      <!--begin::Item-->
                                                      <div class="m-accordion__item">
                                                          <div class="m-accordion__item-head" role="tab" id="m_accordion_7_item_1_head-offline" data-toggle="collapse" href="#m_accordion_7_item_1_body-offline" aria-expanded="true">
                                                              <span class="m-accordion__item-icon ex-code">
                                                                  ex34
                                                              </span>
                                                              <span class="m-accordion__item-title ex-name">
                                                                  <p>Grade 5 Star silver package 2021</p>
                                                                  <span class="days start"><strong>Start:</strong> -</span>
                                                                  <span class="days end"><strong>End:</strong> -</span>
                                                              </span>
                                                              <div class="other-option">
                                                                  <span class="badge badge-pill badge-light due">Any time</span>
                                                                  <a class="btn btn-primary exam-list" href="#" role="button" data-toggle="modal" data-target="#start-exam-modal">Complete Exam</a>
                                                                  <a class="more" href="#"><img src="images/dots.png" /></a>
                                                              </div>
                                                          </div>
                                                          <div class="m-accordion__item-body collapse" id="m_accordion_7_item_1_body-offline" role="tabpanel" aria-labelledby="m_accordion_7_item_1_head-offline" data-parent="#m_accordion_7">
                                                              <div class="m-accordion__item-content">
                                                                <div class="row">
                                                                    <div class="col-md-8">
                                                                      <div class="left-exam">
                                                                        <div class="download-row">
                                                                          <div class="download-item">
                                                                            <a href="#">
                                                                              <img src="images/pdf.png" /> Download Question Paper
                                                                            </a>
                                                                          </div>
                                                                          <div class="download-item">
                                                                            <a href="#">
                                                                              <img src="images/pdf.png" /> Download  Answer Sheet
                                                                            </a>
                                                                          </div>
                                                                        </div>
                                                                          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                                                          quis nostrud exercitation ullamco laboris nisi</p>
                                                                      </div>
                                                                    </div>
                                                                    <div class="col-md-4"></div>
                                                                </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <!--end::Item-->
                                                      <!--begin::Item-->
                                                      <div class="m-accordion__item">
                                                          <div class="m-accordion__item-head collapsed" role="tab" id="m_accordion_7_item_2_head-offline" data-toggle="collapse" href="#m_accordion_7_item_2_body-offline" aria-expanded="    false">
                                                              <span class="m-accordion__item-icon ex-code">
                                                                  ex34
                                                              </span>
                                                              <span class="m-accordion__item-title ex-name">
                                                                  <p>Grade 5 Star silver package 2021</p>
                                                                  <span class="days start"><strong>Start:</strong>-</span>
                                                                  <span class="days end"><strong>End:</strong>-</span>
                                                              </span>
                                                              <div class="other-option">
                                                                  <span class="badge badge-pill badge-light due">Any time</span>
                                                                  <a class="btn btn-primary exam-list" href="#" role="button" data-toggle="modal" data-target="#start-exam-modal">Complete Exam</a>
                                                                  <a class="more" href="#"><img src="images/dots.png" /></a>
                                                              </div>

                                                          </div>
                                                          <div class="m-accordion__item-body collapse" id="m_accordion_7_item_2_body-offline" role="tabpanel" aria-labelledby="m_accordion_7_item_2_head-offline" data-parent="#m_accordion_7">
                                                              <div class="m-accordion__item-content">
                                                                <div class="row">
                                                                    <div class="col-md-8">
                                                                      <div class="left-exam">
                                                                        <div class="download-row">
                                                                          <div class="download-item">
                                                                            <a href="#">
                                                                              <img src="images/pdf.png" /> Download Question Paper
                                                                            </a>
                                                                          </div>
                                                                          <div class="download-item">
                                                                            <a href="#">
                                                                              <img src="images/pdf.png" /> Download  Answer Sheet
                                                                            </a>
                                                                          </div>
                                                                        </div>
                                                                          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                                                          quis nostrud exercitation ullamco laboris nisi</p>
                                                                      </div>
                                                                    </div>
                                                                    <div class="col-md-4"></div>
                                                                </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <!--end::Item-->
                                                  </div>
                                                </div>
                                                <div class="tab-pane" id="top2-offline" role="tabpanel">
                                                  <div class="m-accordion m-accordion--default m-accordion--solid m-accordion--section m-accordion--toggle-arrow" id="m_accordion_7" role="tablist">
                                                      <!--begin::Item-->
                                                      <div class="m-accordion__item">
                                                          <div class="m-accordion__item-head" role="tab" id="m_accordion_28_item_1_head-offline" data-toggle="collapse" href="#m_accordion_28_item_1_body-offline" aria-expanded="true">
                                                              <span class="m-accordion__item-icon ex-code">
                                                                  ex34
                                                              </span>
                                                              <span class="m-accordion__item-title ex-name">
                                                                  <p>Grade 5 Star silver package 2021</p>
                                                                  <span class="days start"><strong>Start:</strong>-</span>
                                                                  <span class="days end"><strong>End:</strong>-</span>
                                                              </span>
                                                              <div class="other-option">
                                                                  <span class="badge badge-pill badge-light due">Anytime</span>
                                                                  <a class="more" href="#"><img src="images/dots.png" /></a>
                                                              </div>
                                                          </div>
                                                          <div class="m-accordion__item-body" id="m_accordion_28_item_1_body-offline" role="tabpanel" aria-labelledby="m_accordion_28_item_1_head-offline" data-parent="#m_accordion_7">
                                                              <div class="m-accordion__item-content">
                                                                <div class="row">
                                                                    <div class="col-md-8">
                                                                      <div class="left-exam">
                                                                        <div class="download-row">
                                                                          <div class="download-item">
                                                                            <a href="#">
                                                                              <img src="images/pdf.png" /> Download Question Paper
                                                                            </a>
                                                                          </div>
                                                                          <div class="download-item">
                                                                            <a href="#">
                                                                              <img src="images/pdf.png" /> Download  Answer Sheet
                                                                            </a>
                                                                          </div>
                                                                        </div>
                                                                          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                                                          quis nostrud exercitation ullamco laboris nisi</p>
                                                                      </div>
                                                                    </div>
                                                                    <div class="col-md-4"></div>
                                                                </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <!--end::Item-->
                                                      <!--begin::Item-->
                                                      <div class="m-accordion__item">
                                                          <div class="m-accordion__item-head collapsed" role="tab" id="m_accordion_29_item_2_head-offline" data-toggle="collapse" href="#m_accordion_29_item_2_body-offline" aria-expanded="    false">
                                                              <span class="m-accordion__item-icon ex-code">
                                                                  ex34
                                                              </span>
                                                              <span class="m-accordion__item-title ex-name">
                                                                  <p>Grade 5 Star silver package 2021</p>
                                                                  <span class="days start"><strong>Start:</strong>-</span>
                                                                  <span class="days end"><strong>End:</strong>-</span>
                                                              </span>
                                                              <div class="other-option">
                                                                  <span class="badge badge-pill badge-light due">Anytime</span>
                                                                  <a class="more" href="#"><img src="images/dots.png" /></a>
                                                              </div>

                                                          </div>
                                                          <div class="m-accordion__item-body collapse" id="m_accordion_29_item_2_body-offline" role="tabpanel" aria-labelledby="m_accordion_29_item_2_head-offline" data-parent="#m_accordion_7">
                                                              <div class="m-accordion__item-content">
                                                                <div class="row">
                                                                    <div class="col-md-8">
                                                                      <div class="left-exam">
                                                                        <div class="download-row">
                                                                          <div class="download-item">
                                                                            <a href="#">
                                                                              <img src="images/pdf.png" /> Download Question Paper
                                                                            </a>
                                                                          </div>
                                                                          <div class="download-item">
                                                                            <a href="#">
                                                                              <img src="images/pdf.png" /> Download  Answer Sheet
                                                                            </a>
                                                                          </div>
                                                                        </div>
                                                                          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                                                          quis nostrud exercitation ullamco laboris nisi</p>
                                                                      </div>
                                                                    </div>
                                                                    <div class="col-md-4"></div>
                                                                </div>
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <!--end::Item-->
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                </div>                                                            
                              </div>
                            <div class="col-md-3">
                              <div class="shedule">
                                <h2>Next Exam Sheduled</h2>
                                <img src="images/clock.png" />
                                <div class="btn-group" role="group" aria-label="Basic example">
                                  <button type="button" class="btn btn-secondary">
                                    03
                                    <span>Days</span>
                                  </button>
                                  <button type="button" class="btn btn-secondary">
                                    11
                                    <span>Hours</span>
                                  </button>
                                  <button type="button" class="btn btn-secondary">
                                  33
                                    <span>Mins</span>
                                  </button>
                                </div>

                              </div>
                              <div class="result-area">
                                  <h2>Past Exam Result</h2>
                                  <img src="images/result.png" />

                                  <div class="result-row">
                                    <span class="result-name">Chemestry</span>
                                    <span class="result-count">(80/100) <strong>80%</strong></span>
                                    <div class="result-line">
                                      <div class="progress">
                                        <div class="progress-bar bg-success" role="progressbar" style="width: 80%" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="result-row">
                                    <span class="result-name">Diploma in IT</span>
                                    <span class="result-count">(60/100) <strong>60%</strong></span>
                                    <div class="result-line">
                                      <div class="progress">
                                        <div class="progress-bar bg-info" role="progressbar" style="width: 60%" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="result-row">
                                    <span class="result-name">Business Management</span>
                                    <span class="result-count">(40/100) <strong>40%</strong></span>
                                    <div class="result-line">
                                      <div class="progress">
                                        <div class="progress-bar bg-warning" role="progressbar" style="width: 40%" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                                      </div>
                                    </div>
                                  </div>

                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="tab-pane" id="m_tabs_6_2" role="tabpanel">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="search-section">
                                  <div class="row">
                                    <div class="col-md-3">
                                      <div class="form-group">
                                        <select @change="getFilterOptionData('courses')" name="courses" required id="courses" class="form-control" style="width:100%">
                                          <option value="" >Select Course</option>
                                          <option v-for="course in courseList" :key="course.id" :value="course.id">{{course.name}}</option>
                                        </select>
                                      </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                          <select @change="getFilterOptionData('subjects')" name="subjects" required id="subjects" class="form-control" style="width:100%">
                                            <option value="" v-if="subjectList.length > 0">Select Subject</option>
                                            <option value="" v-else>No Subjects</option>
                                            <option v-for="subject in subjectList" :key="subject.id" :value="subject.id" >{{subject.name}}</option>
                                          </select>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                          <select name="exams" required id="exams" class="form-control" style="width:100%">
                                            <option value="" v-if="examsList.length > 0">Select Exam</option>
                                            <option value="" v-else >No Exams</option>
                                            <option v-for="exam in examsList" :key="exam.id" :value="exam.id" >{{exam.exam_name}}</option>
                                          </select>
                                        </div>
                                    </div>
                                     <div class="col-md-2">
                                        <div class="form-group">
                                          <input type="text" name="academic_year" id="academic_year" class="form-control" placeholder="Academic Year" />
                                        </div>
                                    </div>
                                    <div class="col-md-1"></div>
                                    <div class="col-md-2">
                                      <button @click="searchExam()" type="submit" class="btn btn-primary btn-info" :disabled="(examsList.length > 0)? false: true">Search Now</button>
                                    </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                          <div v-if="examsData.length > 0" class="row">
                            <div v-for="(exam, index) in examsData" :key="index" class="col-md-4 col-lg-3 col-xl-3 course-card">
                              <div class="course-card">
                                <div class="modern-card">
                                  <div class="modern-head">
                                    <div class="st offline">{{(exam.exam_availablitiy == 0)? 'Offline': 'Online'}}</div>
                                    <h2>{{(exam.course)? exam.course.name: ''}}</h2>
                                  </div>
                                  <div class="modern-stat">
                                    <div class="time-md">{{exam.exam_name}}</div>
                                  </div>
                                  <div class="modern-stat sub-item">
                                    <ul>
                                      <li>Exam Date: {{exam.start_date.split(' ')[0]}}</li>
                                      <li>Duration: {{exam.duration}} Minutes </li>
                                    </ul>
                                  </div>
                                  <div class="start-time">Start Time: {{exam.start_date.split(' ')[1]}}</div>
                                  <div class="time-area">
                                    <div class="subs start">
                                      MCQ: <span>{{exam.mcqCounts}}</span>
                                    </div>
                                    <div class="subs end">
                                      Easay: <span>{{exam.essayCounts}}</span>
                                    </div>
                                  </div>

                                  <h3 v-if="exam.is_payable">{{currency.code}} {{exam.exam_cost}}</h3>
                                  <h3 v-else class="free">Free</h3>

                                  <div class="modern-body">
                                    <button v-if="exam.is_payable" @click="setPaymentModal(exam.id, exam.exam_cost)" type="button" data-toggle="modal" data-target="#online-pay-modal" class="btn btn-primary btn-info" :disabled="exam.isRegistered">
                                      {{(exam.isRegistered)? 'Registered': 'Pay & Register'}}
                                    </button>                                    
                                    <button v-else type="button" @click="setRegisterModal(exam.id, exam.exam_cost)" data-toggle="modal" data-target="#free-register-exam-modal" class="btn btn-primary btn-info free" :disabled="exam.isRegistered">
                                      {{(exam.isRegistered)? 'Registered': 'Register'}}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else class="row">
                            <div class="col-md-4 col-lg-3 col-xl-3">
                              <div class="empty-data">
                                <img src="/media/icons/empty.png" />
                                <h2>Exams not available</h2>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="tab-pane" id="m_tabs_6_3" role="tabpanel">
                            <div class="card-body payment">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="pay-table">
                                            <table class="table table-sm table-hover table-light">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Date</th>
                                                        <th scope="col">Exam Name</th>
                                                        <th scope="col">Amount</th>
                                                        <th scope="col">Ref No</th>
                                                    </tr>
                                                    <tr>
                                                        <td scope="col">2021-09-30</td>
                                                        <td scope="col">Diploma in IT</td>
                                                        <td scope="col">Rs.35000.00</td>
                                                        <td scope="col">0590595959</td>
                                                    </tr>
                                                     <tr>
                                                        <td scope="col">2021-09-30</td>
                                                        <td scope="col">Diploma in IT</td>
                                                        <td scope="col">Rs.35000.00</td>
                                                        <td scope="col">0590595959</td>
                                                    </tr>
                                                    <tr>
                                                        <td scope="col">2021-09-30</td>
                                                        <td scope="col">Diploma in IT</td>
                                                        <td scope="col">Rs.35000.00</td>
                                                        <td scope="col">0590595959</td>
                                                    </tr>
                                                </thead>
                                                <tbody id="payment_history_body"></tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- start Exam Modal -->
    <div class="modal fade exam-modal" id="start-exam-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <h2>Diploma in IT</h2>
            <h3>Do you want to start Exam Now?</h3>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Start Now</button>
          </div>
        </div>
      </div>
    </div>
        <!-- continue Exam Modal -->
    <div class="modal fade exam-modal" id="continue-exam-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <h2>Diploma in IT</h2>
            <h3>Do you want to continue Exam again?</h3>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary continue">Continue Now</button>
          </div>
        </div>
      </div>
    </div>

    <!-- free-regster Exam Modal -->
    <div class="modal fade exam-modal" id="free-register-exam-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <input type="hidden" name="selectedFreeExamId" id="selectedFreeExamId">
            <h5 class="modal-title" id="exampleModalLabel">Register Now</h5>
          </div>
          <div class="modal-body">
            <div class="alert alert-success" id="examReg_success" style="display:none" >You have successfully registered to the exam.</div>
            <h5>Are you sure want to register this Exam?</h5>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="registerExamFree()">Yes Register Now</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Payment modal -->
    <div class="modal fade" id="online-pay-modal" tabindex="-1" role="dialog" aria-labelledby="payment-modal-title" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <input type="hidden" name="selectedExamId" id="selectedExamId">
            <input type="hidden" name="examCost" id="examCost">
            <h5 class="modal-title" id="payment-modal-title">
              Online payment
            </h5>
            <img class="close" src="/media/icons/close.png" data-dismiss="modal" aria-label="Close" width="53px" />
          </div>
          <div class="modal-body">
            <div class="alert alert-success" id="submitonline_success" style="display:none" >
              Please wait while we process your request....
            </div>
            <div class="alert alert-danger" id="submitonline_error" style="display:none" ></div>
            <form id="payment-data">
              <div class="form-group">
                <label>Payment Amount ({{currency.code}})</label>
                <input type="number" class="form-control" id="exam_cost" name="exam_cost" disabled/>
              </div>
              <br />
              <div class="form-group">
                <a href="/doc/Terms and Conditions.pdf" download>Read terms and Conditions</a>
              </div>
              <div class="form-group form-check">
                <input type="checkbox" v-model="agreementChecked" class="form-check-input" id="terms_check" />
                <label class="form-check-label" for="exampleCheck1">I have read and agreed with the terms and conditions</label>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" :disabled="!agreementChecked" @click="payExamFeeAndRegister()">Proceed to pay</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  var Config = require('../router/Config')
  // var $ = require('jquery')
  var Cookies = require('vue-cookies')
  var userPermissions = Cookies.get('userPermissions')

  var examDashboard = {
    name: 'test',
    components: {},
    props: [],
    data () {
      return {
        examsData: [],
        onlineExamData: [],
        offlineExamData: [],
        examsList: [],
        courseList: [],
        subjectList: [],
        currency: [],
        clientId: Cookies.get('clientId'),
        agreementChecked: false,
      }
    },
    beforeCreate: function () {
      if (!userPermissions.course_view) {
        this.$router.push('/')
      }
    },
    mounted () {
      this.user = Cookies.get('userDetail')
      this.getexamDashboard()
    },
    updated() {
    },
    methods: {
      getexamDashboard: function () {
        this.axios.get(Config.API_URL + '/api/fe/exam/exam-dashboard/' + '?token=' + Cookies.get('accessToken') + '&studentId=' + Cookies.get('studentId')).then(response => {
          this.examsData = response.data.examsData
          this.onlineExamData = response.data.studentOnlineExam
          this.offlineExamData = response.data.studentOfflineExam
          this.courseList = response.data.courseList
          this.subjectList = response.data.subjectList
          this.examsList = response.data.examsList
          this.currency = response.data.currency
          Cookies.set('currency', this.currency)
          console.log(response.data)
          
        }).catch(function (error) {
          console.log(error)
        })
      },
      setPaymentModal: function (examId, examCost) {
        $('#selectedExamId').val(examId)
        $('#examCost').val(examCost)
        $('#exam_cost').val(examCost)
      },
      payExamFeeAndRegister: function () {
        var selectedExamId = $('#selectedExamId').val()
        var random = Math.floor(1000 + Math.random() * 9000)
        var orderid = selectedExamId + 'T' + random
        var enteredAmount = $('#examCost').val()

        Cookies.set('installment_id', orderid)
        Cookies.set('exam_id', selectedExamId)
        Cookies.set('payment_purpose', 'exam') //the reason for the payment

        // need to handle with payment gateway related to the client.
     
      },
      setRegisterModal: function (examId) {
        $('#selectedFreeExamId').val(examId)
      },
      registerExamFree: function () {
        var examId = $('#selectedFreeExamId').val()
        this.axios.get(Config.API_URL + '/api/fe/exam/register-exam/' + '?token=' + Cookies.get('accessToken') + '&examId=' + examId + '&studentId=' + Cookies.get('studentId')).then(response => {
          var result = response.data
          console.log(result)
          $('#examReg_success').fadeTo(5000, 500).slideUp(500, function () {
            $('#free-register-exam-modal').modal('hide')
          })
          
        }).catch(function (error) {
          console.log(error)
        })
      },
      getFilterOptionData: function (optionType) {
        var courseId = $('#courses').val()
        var subjectId = $('#subjects').val()

        this.axios.get(Config.API_URL + '/api/fe/exam/get-filter-option-data/' + '?token=' + Cookies.get('accessToken') 
          + '&courseId=' + courseId  
          + '&subjectId=' + subjectId 
          + '&optionType=' + optionType 
          + '&clientId=' + this.clientId )
        .then(response => {
          var result = response.data
          console.log('get-filter-option-data')
          console.log(result)
          if(optionType == 'courses') {
            this.subjectList = response.data.subjectList        
            this.examsList = response.data.examsList
          } else if (optionType == 'subjects') {
            this.examsList = response.data.examsList
          }          
        }).catch(function (error) {
          console.log(error)
        })
      },
      searchExam: function () {
        var courseId = $('#courses').val()
        var subjectId = $('#subjects').val()
        var examId = $('#exams').val()
        var academic_year = $('#academic_year').val()

        this.axios.get(Config.API_URL + '/api/fe/exam/search-exam/' + '?token=' + Cookies.get('accessToken') 
          + '&courseId=' + courseId  
          + '&subjectId=' + subjectId 
          + '&examId=' + examId 
          + '&academicYear=' + academic_year 
          + '&studentId=' + Cookies.get('studentId') 
          + '&clientId=' + this.clientId )
        .then(response => {
          var result = response.data
          console.log('searchExam')
          console.log(result)
          this.examsData = response.data.examsData       
        }).catch(function (error) {
          console.log(error)
        })
      }
      
    }
  }
  export default examDashboard
</script>

<style scoped lang="scss">
    @import "../assets/scss/component/exam/exam";
</style>
